import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";


export const OM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['om.OrganizationalUnit', {route: '/om/organizationalUnits'}],
            ['om.Position', {route: '/om/positions'}],
            ['om.Employee', {route: '/om/employees'}],
            ['om.EmployeePosition', {route: '/om/employeePositions'}],
            ['om.Department', {route: '/om/departments'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
